"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseApi = exports.API_PATHS = void 0;
const axios_1 = __importDefault(require("axios"));
const aws_amplify_1 = require("aws-amplify");
const frontend_utils_1 = require("frontend-utils");
const utils_1 = require("../utils");
const constants_1 = require("../constants");
const API_HOST = constants_1.BACKEND_URL.replace(/^https:\/\//, "");
const HTTP_METHODS_MAP = {
    POST: "POST",
    GET: "GET",
};
exports.API_PATHS = {
    APP_CREATE: "/v2/app/create",
    APP_UPDATE: "/v2/app/update",
    APP_LIST: "/v2/app/list",
    APP_LOGS: "/v2/app/logs",
    APP_TRANSACTIONS: "/v2/app/transaction/history",
    COMPLETE_AUTH: "/v2/user/completeAuth",
    ACCOUNT_INFO: "/v2/account/info",
    ACCOUNT_MANAGE: "/v2/account/manage",
    APP_STATS: "/v2/app/stats",
};
const API_CONFIG = {
    [exports.API_PATHS.APP_CREATE]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.APP_CREATE,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.APP_UPDATE]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.APP_UPDATE,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.APP_LIST]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.APP_LIST,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.COMPLETE_AUTH]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.COMPLETE_AUTH,
        apiSignatureRequired: false,
    },
    [exports.API_PATHS.ACCOUNT_INFO]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.ACCOUNT_INFO,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.ACCOUNT_MANAGE]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.ACCOUNT_MANAGE,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.APP_LOGS]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.APP_LOGS,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.APP_TRANSACTIONS]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.APP_TRANSACTIONS,
        apiSignatureRequired: true,
    },
    [exports.API_PATHS.APP_STATS]: {
        method: HTTP_METHODS_MAP.POST,
        path: exports.API_PATHS.APP_STATS,
        apiSignatureRequired: true,
    },
};
const addApiSignature = (apiConfig, existingHeaders, requestBody) => __awaiter(void 0, void 0, void 0, function* () {
    const timeStamp = Date.now().toString();
    const currentUser = yield (0, utils_1.getUserInfo)();
    const requestBodyString = requestBody ? JSON.stringify(requestBody) : "";
    const timestampHeader = `${constants_1.X_TIMESTAMP_HEADER}:${timeStamp}`;
    if (!currentUser) {
        throw new Error("User not found");
    }
    const sessionKey = (yield frontend_utils_1.SessionKeysUtils.fetchKeysFromDb({
        keyPrefix: constants_1.SESSION_KEY_PREFIX,
        parsedUser: currentUser,
        sessionId: (yield aws_amplify_1.Auth.currentSession()).getIdToken().payload.origin_jti,
        keyType: frontend_utils_1.SessionKeysUtils.SESSION_KEY_TYPES.CRYPTO,
    }));
    if (!sessionKey || !sessionKey.privateKey) {
        throw new Error("Session key not found");
    }
    const signedRequest = yield frontend_utils_1.CryptoUtils.signRequest(requestBodyString, sessionKey, timestampHeader, apiConfig.method, apiConfig.path, API_HOST);
    existingHeaders.append(constants_1.X_TIMESTAMP_HEADER, timeStamp);
    signedRequest &&
        existingHeaders.append(constants_1.X_API_SIGNATURE_HEADER, signedRequest);
});
const addAuthorizationHeader = (existingHeaders) => __awaiter(void 0, void 0, void 0, function* () {
    const idToken = (yield aws_amplify_1.Auth.currentSession()).getIdToken().getJwtToken();
    existingHeaders.append("Authorization", `Bearer ${idToken}`);
});
const baseApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ apiPath, requestBody = null, }) {
    const apiConfig = API_CONFIG[apiPath];
    if (!apiConfig)
        throw new Error(`Invalid api path: ${apiPath}`);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    requestBody = requestBody || {};
    // Add api signature header if api requires it
    if (apiConfig.apiSignatureRequired)
        yield addApiSignature(apiConfig, headers, requestBody);
    // Add authorization header if api is authenticated
    yield addAuthorizationHeader(headers);
    const headersObj = {};
    for (const headerPair of headers.entries()) {
        headersObj[headerPair[0]] = headerPair[1];
    }
    const apiCallConfig = {
        method: apiConfig.method,
        url: `${constants_1.BACKEND_URL}${apiConfig.path}`,
        headers: headersObj,
        data: undefined, // Add the 'data' property with type 'any'
    };
    if (requestBody)
        apiCallConfig.data = JSON.stringify(requestBody);
    return (yield (0, axios_1.default)(apiCallConfig)).data;
});
exports.baseApi = baseApi;
